import { gql } from '@apollo/client';

export const GET_AUDIT_LOG_FOR_OBJECT = gql`
  query GetAuditLogForObject($objectId: String!) {
    getAuditLogForObject(objectId: $objectId) {
      id
      objectId
      notes
      createdAt
      createdBy
      tenantId
    }
  }
`;
